<script>
  import { useForm } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FormLayout from '../../components/form_layout.svelte'
  import FormSection from '../../components/form_section.svelte'
  import NumberField from '../../components/form/number_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'
  import { Button } from '../../components/ui'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  // Labels, help copy and defaults come from the server. Validation does too:
  // each field is checked live by a Precognition request to the update action
  // (AdminSite::FeedRankingController / FeedRankingSetting::BOUNDS), and again on Save.
  let { weights, defaults, sections, intro } = $props()

  const keys = sections.flatMap((section) => section.fields.map((field) => field.key))
  const pick = (source) => Object.fromEntries(keys.map((key) => [key, source[key]]))

  const form = useForm({ feed_ranking_setting: pick(weights) }).withPrecognition('patch', '/feed-ranking')
  liveValidate(form, 'feed_ranking_setting')

  const path = (key) => `feed_ranking_setting.${key}`
  const helpFor = (field) => `${field.help} Default: ${defaults[field.key]}.`

  // Fills the form only (liveValidate re-checks the changed fields); nothing saves until Save.
  const resetToDefaults = () => {
    $form.feed_ranking_setting = pick(defaults)
  }

  const submit = (event) => {
    event.preventDefault()
    $form.patch('/feed-ranking', { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Feed Ranking" subtitle="Moments community feed weights" />

  <FormLayout onsubmit={submit}>
    <p class="text-sm text-base-content/60">{intro}</p>

    {#each sections as section (section.key)}
      <FormSection title={section.title}>
        {#each section.fields as field (field.key)}
          <NumberField
            bind:value={$form.feed_ranking_setting[field.key]}
            label={field.label}
            name={field.key}
            help={helpFor(field)}
            error={$form.errors[path(field.key)]}
            step={field.step}
          />
        {/each}
      </FormSection>
    {/each}

    {#if $form.errors.base}<p class="text-sm text-error">{$form.errors.base}</p>{/if}

    {#snippet footer()}
      <Button variant="ghost" size="sm" icon="undo" onclick={resetToDefaults}>Reset to defaults</Button>
      <SubmitButton processing={$form.processing} full={false} />
    {/snippet}
  </FormLayout>
</Layout>
